// src/components/dashboard/ExperimentalSideVignette.tsx
// [UI experimental] Side frost — same recipe as the header, stretched left and right.
import React from 'react';
import { EXP_VIGNETTE, EXP_VIGNETTE_LEFT } from './experimentalLayout';

const BOTH_BLUR: { blur: number; mask: string }[] = [
  { blur: 0.5, mask: 'linear-gradient(to right, black 0%, black 16%, transparent 48%, transparent 52%, black 84%, black 100%)' },
  { blur: 1.25, mask: 'linear-gradient(to right, black 0%, black 10%, transparent 38%, transparent 62%, black 90%, black 100%)' },
  { blur: 2.25, mask: 'linear-gradient(to right, black 0%, black 4%, transparent 28%, transparent 72%, black 96%, black 100%)' },
];

const LEFT_BLUR: { blur: number; mask: string }[] = [
  { blur: 0.5, mask: 'linear-gradient(to right, black 0%, black 16%, transparent 48%)' },
  { blur: 1.25, mask: 'linear-gradient(to right, black 0%, black 10%, transparent 38%)' },
  { blur: 2.25, mask: 'linear-gradient(to right, black 0%, black 4%, transparent 28%)' },
];

interface ExperimentalSideVignetteProps {
  /** Dashboard keeps both edges. Leads only needs the left rail wash. */
  edge?: 'both' | 'left';
}

const ExperimentalSideVignette: React.FC<ExperimentalSideVignetteProps> = ({
  edge = 'both',
}) => {
  const layers = edge === 'left' ? LEFT_BLUR : BOTH_BLUR;
  const wash = edge === 'left' ? EXP_VIGNETTE_LEFT : EXP_VIGNETTE;

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden>
      {layers.map((layer) => (
        <div
          key={layer.blur}
          className="absolute inset-0"
          style={{
            backdropFilter: `blur(${layer.blur}px)`,
            WebkitBackdropFilter: `blur(${layer.blur}px)`,
            maskImage: layer.mask,
            WebkitMaskImage: layer.mask,
          }}
        />
      ))}
      <div className="absolute inset-0" style={{ background: wash }} />
    </div>
  );
};

export default ExperimentalSideVignette;
